<app-logo-area [breadcrumbs]="[{'display': 'Content Platform', commands: ['/o', this.organization()?.id]}]"></app-logo-area>
<main>
  <app-headline-section [title]="'Storage Roots'"></app-headline-section>
  <section class="cl-section cl-section-regular cl-form">
    <div class="container">

      <div class="row">
        <div class="col-12">
          <table class="cl-table-data">
          <thead>
            <tr>
              <th class="cl-table-head"></th>
              <th class="cl-table-head">Bucket Name</th>
              <th class="cl-table-head">Last Modified</th>
            </tr>
          </thead>
          @if (loading()) {
            <tbody>
              <tr appLoadRow [state]="state()" thing="storage roots"></tr>
            </tbody>
          } @else {
            <tbody>
              @if (roots().length === 0) {
                <tr class="cl-tr-no-data">
                  <td colspan="100">No data available.</td>
                </tr>
              }
              @for (it of roots(); track it) {
                <tr>
                  <td>
                    <div style="margin-top: -8px; margin-bottom: -12px;">
                      <i class="fas fa-hdd"></i>
                    </div>
                  </td>
                  <td>
                    <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                      <a [routerLink]="it | link"
                        (click)="$event.stopPropagation()">
                        {{ it.name | orgResolver }}
                      </a>
                    </div>
                  </td>
                  <td class="cl-td-time">
                    <div >
                      <app-date [value]="it.last_modified" empty="—" />
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }

        </table>
      </div>
    </div>


  </div>
</section>
</main>
